import useStore from "../../../store"
import { useState } from "react"
import formatter from "../../../constants/currencyFormatter"
import { useTranslation } from "react-i18next"
import BreakdownItem from "./BreakdownItem"
import { CollapsibleInfoItem } from "../../common/InfoItem"
import { IoIosInformationCircle } from "react-icons/io"
import ReusableDrawer from "../../common/ReusableDrawer"
import { colors } from "../../../utilities/colors"

export default function PaymentBreakdown({ paymentType }) {
  const amountDueOn = useStore((state) => state.amountDueOn)
  const unit = useStore((state) => state.unit)
  const { t } = useTranslation()

  const [showFeeBreakdown, setShowFeeBreakdown] = useState(false)

  const principalOrCurtailment = {
    3: { title: t('Principal'), amount: amountDueOn?.principal },
    1: { title: t('Curtailment'), amount: amountDueOn?.curtailment }
  }

  return(
    <div className="mx-1 pr-1">
      <CollapsibleInfoItem title={t('Payment Breakdown')}>
        <div className="grid grid-cols-2 gap-y-1 text-sm">
          {principalOrCurtailment[paymentType] && (
            <BreakdownItem
              title={principalOrCurtailment[paymentType].title}
              amount={formatter.format(principalOrCurtailment[paymentType].amount)}
            />
          )}
          <BreakdownItem
            title={t('Interest')}
            amount={formatter.format(amountDueOn?.interest)}
          />
          <BreakdownItem
            title={
              <span className="flex items-center gap-1">
                {t('Fees')}
                <IoIosInformationCircle
                  className="hover:cursor-pointer"
                  onClick={() => setShowFeeBreakdown(!showFeeBreakdown)}
                />
              </span>
            }
            dataTestId={'fees'}
            amount={formatter.format((parseFloat(amountDueOn?.fees) - parseFloat(amountDueOn?.insurance)) + (paymentType === 1 ? parseFloat(amountDueOn?.curtailment_fee) : 0))}
          />
          {amountDueOn?.insurance > 0 &&
            <BreakdownItem
              title={t('Insurance')}
              amount={formatter.format(parseFloat(amountDueOn?.insurance))}
            />
          }
          {amountDueOn?.add_to_reserves > 0 && paymentType === 3 &&
            <BreakdownItem
              title={t('Reserves Added')}
              amount={formatter.format(parseFloat(amountDueOn?.add_to_reserves))}
            />
          }
          {amountDueOn?.transportation > 0 &&
            <BreakdownItem
              title={t('Transportation')}
              amount={formatter.format(parseFloat(amountDueOn?.transportation))}
            />
          }
        </div>
      </CollapsibleInfoItem>

      {showFeeBreakdown &&
        <ReusableDrawer
          isOpen={showFeeBreakdown}
          onClose={() => setShowFeeBreakdown(false)}
          placement="bottom"
          title="Fee Breakdown"
          bgColor={colors.grey900}
          titleStyle="lg:flex lg:justify-center"
          bodyStyle="md:flex md:items-center md:justify-center"
          bodyContent={
            <div className="lg:w-1/3 md:w-2/3 grid grid-cols-2 gap-y-1 text-sm">
              {unit.attributes['active-fees'].map((fee) => {
                return <BreakdownItem
                  title={fee.memo}
                  amount={formatter.format(fee.amount)}
                />
              })}

            </div>
          }
        />
      }
    </div>
  )
}